import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Barcode Off"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-barcode-off',
    templateUrl: './icon-barcode-off.component.html',
    styleUrls: ['./icon-barcode-off.component.scss'],
    standalone: false
})
export class IconBarcodeOffComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
